import {Repository, createRepository} from '@/repositories/Base/Repository'

class RangeRepository extends Repository {
    endpoint = 'vam/equipment'

    listVnsReports(params) {
        return this.$axios.get(`${this.endpoint}/list-vns-reports`, {params})
    }

    fetchAll(params) {
        return this.$axios.get(`${this.endpoint}/ranges`, {params})
    }
}

export default new RangeRepository()

export const create = createRepository(RangeRepository)
